export default __webpack_public_path__ + "static/media/image1.a46ef4c0.jpg";